/**
 * WordPress dependencies
 */
import { useState, useEffect } from "@wordpress/element";
import { __ } from "@wordpress/i18n";
import { Button } from "@wordpress/components";
import { dispatch } from '@wordpress/data';
import { parse } from '@wordpress/blocks';
import { store as blockEditorStore } from '@wordpress/block-editor';

import Masonry from "react-responsive-masonry";

import PatternContext from '../Context/PatternContext';

import PatternlyHeader from "./PatternlyHeader";
import PatternlySidebar from "./PatternlySidebar";

const PatternlyWrap = () => {
    const [error, setError] = useState(false);
    const [isVisible, setIsVisible] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [queryType, setQueryType] = useState(false);
    const [queryTypeValue, setQueryTypeValue] = useState(false);

    const [patternContent, setPatternContent]  = useState('');
    const [importPattern, setImportPattern]  = useState(false);
    const [importPatternSlug, setImportPatternSlug]  = useState('');
    
    const [loadFavouritePatternData, setLoadFavouritePatternData]  = useState(false);
    const [favouritePatterns, setFavouritePatterns] = useState([]);
    const [favouriteCount, setFavouriteCount] = useState(0);
    const [favouriteContext, setFavouriteContext] = useState('');

    const [patternData, setPatternData]         = useState({});
    const [loadPatternData, setLoadPatternData] = useState(false);
    const [loadMoreButton, setLoadMoreButton] = useState(true);
    const [letsPrintData, setLetsPrintData]     = useState(false);

    const [categoryData, setCategoryData]           = useState({});
    const [loadCategoryData, setLoadCategoryData]   = useState(false);
    const [letsPrintCatData, setLetsPrintCatData]   = useState(false);

    useEffect(  () => {
        if(isVisible) {
            document.querySelector('body').classList.add('pat-disable-scroll');
        }else {
            document.querySelector('body').classList.remove('pat-disable-scroll');
        }

    }, [isVisible] )

    const showLibrary = () => {
        setIsVisible(!isVisible);

        setQueryType('all');
        setLoadPatternData(true);

        setFavouriteContext('count');
        setLoadFavouritePatternData(true);

        setLoadCategoryData(true);
    };

    const hideLibrary = () => {
        setIsVisible(!isVisible);
        setQueryType(false);
    };

    const loadMorePatterns = (event) => {
        let target_page = event.currentTarget.getAttribute('target_page');
        setCurrentPage(target_page);
        setLoadPatternData(true);
    };
    
    const previewPattern = (event) => {
        //add disable scroll class for library.
        let libraryWrap = document.querySelector('.pat-wrapper');
        libraryWrap.classList.add('pat-disable-scroll');

        //add active class.
        let popupWrap = document.querySelector('.pat-popup-wrapper');
        popupWrap.classList.add('pat-popup-active');

        //set img url to popup img.
        let patternItem = event.currentTarget.closest('.pat-item-background');
        let patternItemImg = patternItem.querySelector('img');
        let imageURL = patternItemImg.getAttribute('src');
        let popupImg = document.querySelector('.pat-popup-item-wrapper img');
        popupImg.src = imageURL;

        //set slug to import button.
        let slug = event.currentTarget.getAttribute('slug');
        let type = event.currentTarget.getAttribute('type');

        let popupImportBtn = document.querySelector('.pat-popup-header .pat-import-button');
        popupImportBtn.setAttribute('slug', slug);

        if(type == 'pro') {
            if(PatLocalize.is_pro_activated.length === 0) {
                popupImportBtn.style.display = 'none';
            }
        }else {
            popupImportBtn.style.display = 'flex';
        }

    };
    
    const hidePreviewPattern = (event) => {
        //remove disable scroll class for library.
        let libraryWrap = document.querySelector('.pat-wrapper');
        libraryWrap.classList.remove('pat-disable-scroll');

        //remove active class.
        let popupActive = document.querySelector('.pat-popup-active');
        popupActive.classList.remove('pat-popup-active');
    };
    
    const syncLibrary = (event) => {
        setQueryType('all');
        setQueryTypeValue(false);
        setCurrentPage(1);
        setLoadPatternData(true);
        setLoadCategoryData(true);
    };

    const saveAsFavourite = (event) => {
        //pattern slug.
        let patItem = event.target.closest('.pat-item-background');
        let patternSlug = patItem.getAttribute('data-slug');


        if(!patternSlug) {
            return;
        }

        //api data.
        let data = {
            'nonce': PatLocalize.nonce,
            'pattern_slug': patternSlug
        };

        fetch(PatLocalize.save_as_fav_api_url, {
            method: "POST",
            body: JSON.stringify(data)
        })
        .then((response) => {
            return response.json();
        })
        .then((data) => {
            if (data) {
                //add favourite class to the item.
                patItem.classList.add('pat-fav-pattern');

                setFavouriteCount(favouriteCount + 1);
            }
        })
        .catch((error) => {
            console.log('[WP Pageviews Plugin]');
            console.error(error);
        });
    }

    //get category data.
    useEffect(  () => {

        async function fetchCatAPIData() {
            if(loadCategoryData) {
                await getCatData();
            }
        }

        fetchCatAPIData();

    }, [categoryData, loadCategoryData] )

    //get pattern data.
    useEffect( () => {

        async function fetchAPIData() {
            if(queryType && currentPage && loadPatternData) {
                await getData();
            }
        }

        fetchAPIData();

    }, [queryType, loadPatternData, currentPage] )

    //get favourite pattern data.
    useEffect( () => {

        async function fetchFavAPIData() {
            if(loadFavouritePatternData) {
                await getFavouriteData();
            }
        }

        fetchFavAPIData();

    }, [loadFavouritePatternData] )
    
    //get pattern content.
    useEffect( () => {

        async function fetchPatternContent() {

            if(importPattern && importPatternSlug) {
                await getContent();
            }
            
        }

        fetchPatternContent();

    }, [importPattern, importPatternSlug] )

    async function getCatData(url = '') {

        if( ! PatLocalize.remoteurl ) {
            return;
        }

        if( !url ) {
            url = PatLocalize.remoteurl + "/wp-json/optemiz/v1/patternly/pattern-categories";
        }

        let patSidebar = document.querySelector(".pat-sidebar");
        if(patSidebar) {
            patSidebar.classList.add('pat-skeleton-sidebar-active');
        }

        await Promise.all([
            fetch(url, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then(function(response) {
                return response.json();
            })
            .then( function(response) {
                setCategoryData(response);

                if(patSidebar) {
                    patSidebar.classList.remove('pat-skeleton-sidebar-active');
                }
            })
        ]);

        setLetsPrintCatData(true);
        setLoadCategoryData(false);
    }

    async function getData(url = '') {

        if( ! PatLocalize.remoteurl ) {
            return;
        }

        if( !url ) {

            if(queryType === 'all' && currentPage === 1) {
                url = PatLocalize.pat_plugin_url + 'src/json/default-patterns.json';
            }else {
                url = PatLocalize.remoteurl + "/wp-json/optemiz/v1/patternly/patterns";

                //add query type and value to the URL.
                if(queryType.length > 0 && queryType !== 'all' && queryTypeValue) {
                    url = url + "?query_type=" + queryType + "&query_value=" + queryTypeValue;
                }

                if(currentPage > 1) {
                    url = formatUrl(url);

                    //add page parameter.
                    url += 'page=' + currentPage;

                    if(patternData['data'].length > 0) {
                        let ids = patternData['data'].map((item) => {
                            return item.id;
                        });
        
                        var serializedIds = JSON.stringify(ids);

                        url = formatUrl(url);
                        url +=  "exclude_posts=" + serializedIds;
                    }
                }
            }

            // display loader.
            let entryContent = document.querySelector('.pat-grid-items-entry-content');
            entryContent.classList.add('pat-skeleton-grid-items-active');

            // display sync loader.
            let syncBtn = document.querySelector('.pat-sync-btn');

            syncBtn.classList.add('pat-sync-btn-active');
        }

        await Promise.all([
            fetch(url, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then(function(response) {
                return response.json();
            })
            .then( function(response) {
                let oldData = patternData['data'];
                let newData = response['data'];

                if(oldData && currentPage > 1) {
                    response['data'] = [...oldData, ...newData];
                }

                if(response['load_more'] == 'no') {
                    setLoadMoreButton(false);
                }

                setPatternData(response);

                // hide loader.
                let entryContent = document.querySelector('.pat-grid-items-entry-content');
                entryContent.classList.remove('pat-skeleton-grid-items-active');

                // hide sync loader.
                let syncBtn = document.querySelector('.pat-sync-btn');
                syncBtn.classList.remove('pat-sync-btn-active');
            })
        ]);

        setLetsPrintData(true);
        setLoadPatternData(false);
    }

    /**
     * Get farourite patterns
     * 
     * @param {string} url Api URL 
     * 
     * @returns mixed
     */
    async function getFavouriteData() {

        if( ! PatLocalize.homeurl ) {
            return;
        }

        let url = PatLocalize.homeurl + "/wp-json/optemiz/v1/patternly/get-favourite-patterns";

        await Promise.all([
            fetch(url, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then(function(response) {
                return response.json();
            })
            .then( function(response) {

                if(favouriteContext == 'count') {
                    console.log(response);
                    setFavouriteCount(response.count);
                    setFavouritePatterns(response.data);
                }else {
                    setQueryType('favourite');
                    setQueryTypeValue(response.patterns);
                    setLoadPatternData(true);
                }
                
                setLoadFavouritePatternData(false);

            })
        ]);
    }
    
    async function getContent(url = '') {

        if( ! PatLocalize.homeurl ) {
            return;
        }

        if( !url ) {

            url = PatLocalize.homeurl + "/wp-json/optemiz/v1/patternly/import_pattern";

            //add slug to the URL.
            if(importPatternSlug.length > 0) {
                url = url + "?pattern_slug=" + importPatternSlug;
            }
        }

        await Promise.all([
            fetch(url, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then(function(response) {
                return response.json();
            })
            .then( function(response) {

                if(response.content.length > 0) {
                    let parsedBlocks = parse(response.content);

                    //insert blocks.
                    dispatch( blockEditorStore ).insertBlocks( parsedBlocks );

                    hideLibrary();
                }

                // enable items after importing.
                let patItems = document.querySelectorAll('.pat-item-background');
                if(patItems) {
                    patItems.forEach( patItem => {
                        if(patItem) {
                            patItem.classList.remove('pat-item-disable');
                        }
                    })
                }

            })
        ]);

        setImportPattern(false);
        setImportPatternSlug('');
    }

    function getPatternContent(event) {
        event.preventDefault();

        let importButton = event.target;

        if(!importButton.classList.contains('pat-import-button')) {
            importButton = importButton.parentElement;
        }

        importButton.querySelector('span').innerText = __('Importing...', 'patternly');

        // Disable other items when importing.
        let patItems = document.querySelectorAll('.pat-item-background');
        if(patItems) {
            let patCurrentItem = importButton.closest('.pat-item-background');

            patItems.forEach( patItem => {
                if(patItem !== patCurrentItem) {
                    if(patItem) {
                        patItem.classList.add('pat-item-disable');
                    }
                }
            })
        }

        let slug = importButton.getAttribute('slug');

        if(slug) {
            setImportPattern(true);
            setImportPatternSlug(slug);
        }

    }

    function formatUrl(url) {
        //check if `?` mark exist in the URL or not.
        if(!url.includes('?')) {
            url += "?";
        }else {
            url += "&";
        }

        return url;
    }

    function renderItem() {
        if(patternData && letsPrintData) {
            
            return(
                patternData['data'].map(item => {
                    let className = 'pat-item-background';
                    let isProPattern = false;
                    let patternType = 'free';
                    
                    if(!PatLocalize.is_pro_activated) {
                        if (item.type.length > 0 && item.type === "pro") {
                            className += ' pro-badge';
                            isProPattern = true;
                            patternType = 'pro';
                        }
                    }

                    let itemImage = item.thumbnail;

                    //check if favourite pattern.
                    if(favouritePatterns.includes(item.slug)) {
                        className += ' pat-fav-pattern';
                    }

                    if(queryType === 'all' && currentPage === 1) {
                        itemImage = PatLocalize.pat_plugin_url + 'src/admin/assets/images/pattern-thumbs/' + itemImage;
                    }

                    let patBtn = <a 
                    class="pat-hover-import-button pat-hover-btn pat-import-button" 
                    onClick={getPatternContent}
                    slug={item.slug}>
                        <img src={`${PatLocalize.pat_plugin_url}src/admin/assets/images/downloading.png`} alt="" />
                        <span>{__('Import', 'patternly')}</span>
                    </a>

                    if(isProPattern) {
                        patBtn = <a 
                        class="pat-hover-import-button pat-hover-btn pat-import-button"
                        href={PatLocalize.pat_pro_url}
                        slug={item.slug}>
                            <img src={`${PatLocalize.pat_plugin_url}src/admin/assets/images/gift.png`} alt="" />
                            <span>{__('Get Pro', 'patternly')}</span>
                        </a>
                    }
    
                    return(
                        <div className={className} 
                            data-slug={item.slug}
                            data-type={item.type}
                            data-category={item.category}
                            data-tag={item.tag}
                            >
                            <img src={itemImage} alt="" />

                            <a 
                            class="pat-favourite-icon"
                            onClick={saveAsFavourite}
                            >
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12.0049 2.50001C11.8647 2.49914 11.7271 2.53756 11.6077 2.61092C11.4882 2.68428 11.3917 2.78964 11.3291 2.91505L8.75293 8.0674L2.63575 9.0088C2.49882 9.02996 2.37043 9.08863 2.26482 9.1783C2.1592 9.26798 2.08049 9.38515 2.0374 9.51683C1.99432 9.64851 1.98855 9.78955 2.02073 9.92431C2.05291 10.0591 2.12179 10.1823 2.21973 10.2803L6.45117 14.5117L5.50879 20.6358C5.48771 20.7728 5.50501 20.9129 5.55877 21.0407C5.61253 21.1685 5.70065 21.2789 5.81334 21.3596C5.92604 21.4403 6.0589 21.4882 6.19717 21.498C6.33545 21.5078 6.47374 21.4791 6.59668 21.4151L12 18.5957L17.4033 21.4151C17.5263 21.4791 17.6646 21.5078 17.8028 21.498C17.9411 21.4882 18.074 21.4403 18.1867 21.3596C18.2994 21.2789 18.3875 21.1685 18.4412 21.0407C18.495 20.9129 18.5123 20.7728 18.4912 20.6358L17.5488 14.5117L21.7803 10.2803C21.8782 10.1823 21.9471 10.0591 21.9793 9.92431C22.0115 9.78955 22.0057 9.64851 21.9626 9.51683C21.9195 9.38515 21.8408 9.26798 21.7352 9.1783C21.6296 9.08863 21.5012 9.02996 21.3643 9.0088L15.2471 8.0674L12.6709 2.91505C12.609 2.79112 12.5141 2.68674 12.3965 2.61349C12.2789 2.54023 12.1434 2.50095 12.0049 2.50001Z" fill="#FFFFFF"/>
                                </svg>
                            </a>
    
                            <div class="pat-hover-buttons">
                                {patBtn}
                                <a 
                                class="pat-hover-preview-button pat-hover-btn" 
                                onClick={previewPattern} 
                                type={patternType}
                                slug={item.slug}>
                                    <img src={`${PatLocalize.pat_plugin_url}src/admin/assets/images/eye.png`} alt="" />
                                    <span>{__('Preview', 'patternly')}</span>
                                </a>
                            </div>
                        </div>
                    )
                })
            )
        }
    }

    return (
        <>
            <Button
                className={"pat-library-button"}
                onClick={() => showLibrary()}
            >
                <img src={`${PatLocalize.pat_plugin_url}src/admin/assets/images/logo-white.png`} alt="Patternly" />
            </Button>

            {isVisible && (
                <PatternContext.Provider 
                value={{
                    patternData, 
                    loadPatternData, 
                    categoryData, 
                    letsPrintCatData, 
                    setCurrentPage, 
                    setQueryType, 
                    setQueryTypeValue, 
                    setLoadPatternData, 
                    setLoadMoreButton,
                    setLoadFavouritePatternData,
                    favouriteCount,
                    setFavouriteContext
                    }}>
                    <div class="pat-wrapper">
                        <div class="pat-header">
                            <div class="pat-logo">
                                <a href={PatLocalize.pat_pro_url}>
                                    <img src={`${PatLocalize.pat_plugin_url}src/admin/assets/images/logo.png`} alt="Patternly" />
                                </a>
                            </div>
                            
                            <div class="pat-header-wrapper">
                                <a class="pat-header-btn pat-sync-btn" onClick={(syncLibrary)}>
                                    <img src={`${PatLocalize.pat_plugin_url}src/admin/assets/images/sync.png`} alt="" />
                                    <span>{__('Sync', 'patternly')}</span>
                                </a>

                                {!PatLocalize.is_pro_activated && (
                                    <a class="pat-header-btn pat-pro-btn" href={PatLocalize.pat_pro_url}>
                                        <img src={`${PatLocalize.pat_plugin_url}src/admin/assets/images/gift.png`} alt="" />
                                        <span>{__('Upgrade to Pro', 'patternly')}</span>
                                    </a>
                                ) }

                                <a class="pat-header-icon" href="#"> <img class="close-btn" src={`${PatLocalize.pat_plugin_url}src/admin/assets/images/info.png`} alt="" /></a>
                                <a class="pat-header-icon pat-hide-library" href="#" onClick={() => hideLibrary()}><img class="close-btn" src={`${PatLocalize.pat_plugin_url}src/admin/assets/images/close.png`} alt="" /></a>
                            </div>
                        </div>
                        <div class="pat-body">
                            <PatternlySidebar />

                            <div class="pat-main">
                                <PatternlyHeader />

                                <div class="pat-grid-items-entry-content">
                                    <div class="pat-grid-items-background">
                                        <Masonry columnsCount={3} gutter="30px">
                                            {renderItem()}
                                        </Masonry>
                                    </div>

                                    <div class="pat-skeleton-grid-items-background">
                                        <div class="pat-skeletion-grid-item"></div>
                                        <div class="pat-skeletion-grid-item"></div>
                                        <div class="pat-skeletion-grid-item"></div>
                                        <div class="pat-skeletion-grid-item"></div>
                                        <div class="pat-skeletion-grid-item"></div>
                                        <div class="pat-skeletion-grid-item"></div>
                                        <div class="pat-skeletion-grid-item"></div>
                                        <div class="pat-skeletion-grid-item"></div>
                                        <div class="pat-skeletion-grid-item"></div>
                                        <div class="pat-skeletion-grid-item"></div>
                                        <div class="pat-skeletion-grid-item"></div>
                                        <div class="pat-skeletion-grid-item"></div>
                                    </div>
                                </div>

                                
                                
                                <div class="pat-load-more-btn-wrapper">
                                    {patternData && loadMoreButton && letsPrintData && (
                                        <a class="pat-load-more-btn" 
                                        onClick={loadMorePatterns}
                                        current_offset={patternData['offset']}
                                        target_page={patternData['current_page'] + 1}
                                        >{__('Load More', 'patternly')}</a>
                                    )}
                                </div>
                                
                                {/* Pop Up */}
                                <div class="pat-popup-wrapper">
                                    <div class="pat-popup-inner">
                                        <div class="pat-header pat-popup-header">
                                            <div class="pat-logo">
                                                <a href="">
                                                    <img src={`${PatLocalize.pat_plugin_url}src/admin/assets/images/logo.png`} alt="Patternly" />
                                                </a>
                                            </div>
                                            <div class="pat-header-wrapper">
                                                {!PatLocalize.is_pro_activated && (
                                                    <a class="pat-header-btn pat-pro-btn" href={PatLocalize.pat_pro_url}>
                                                        <img src={`${PatLocalize.pat_plugin_url}src/admin/assets/images/gift.png`} alt="" />
                                                        <span>{__('Upgrade to Pro', 'patternly')}</span>
                                                    </a>
                                                ) }

                                                <a 
                                                class="pat-header-btn pat-pro-btn pat-import-button" 
                                                onClick={getPatternContent}
                                                slug="">
                                                    <img src={`${PatLocalize.pat_plugin_url}src/admin/assets/images/downloading.png`} alt="" />
                                                    <span>{__('Import', 'patternly')}</span>
                                                </a>
                                                <a class="pat-header-icon" href="#"> <img class="close-btn" src={`${PatLocalize.pat_plugin_url}src/admin/assets/images/info.png`} alt="" /></a>
                                                <a class="pat-header-icon pat-popup-cancle-icon" onClick={hidePreviewPattern} href="#"><img class="close-btn" src={`${PatLocalize.pat_plugin_url}src/admin/assets/images/close.png`} alt="" /></a>
                                            </div>
                                        </div>
                                        <div class="pat-popup-item-wrapper">
                                            <img src={`${PatLocalize.pat_plugin_url}src/admin/assets/images/gallery-section-7.png`} alt="" />
                                        </div>

                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </PatternContext.Provider>
                
            )}
        </>
    );
};

export default PatternlyWrap;